/** @file mesh.setTriangles: replaces a mesh's triangles and, optionally, its editor-only edges. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';
import { checkMeshTopology } from './checkMeshTopology';
import { meshDraft } from './meshDraft';
import { sameNumbers } from './sameNumbers';

const index = z.number().int().nonnegative();

/** mesh.setTriangles: triangles are required; `edges` omitted keeps them, null removes them; meshTopology checks both. */
export const command = defineCommand({
  name: 'mesh.setTriangles',
  description: "Replace a mesh's triangles (flat index triples into its vertices) and optionally its editor-only edges (index pairs; null removes them).",
  input: z.object({ target: z.string().min(1), triangles: z.array(index).min(3), edges: z.array(index).nullable().exactOptional() }).strict(),
  apply(draft, input, ctx) {
    const { mesh } = meshDraft(draft, ctx, input.target);
    const sameEdges = input.edges === undefined || sameNumbers(input.edges ?? undefined, mesh.edges);
    if (sameNumbers(input.triangles, mesh.triangles) && sameEdges) return;
    mesh.triangles = [...input.triangles];
    if (input.edges === null) Reflect.deleteProperty(mesh, 'edges');
    else if (input.edges !== undefined) mesh.edges = [...input.edges];
    checkMeshTopology(draft, mesh);
    draft.meta.updatedAt = ctx.now;
  },
});
